export interface ICheckboxValues {
  [key: string]: boolean
}
export interface IOperatorNumbers {
  [key: string]: string
}
export interface ISelectValues {
  [key: string]: string | undefined
}
export interface ITextValues {
  [key: string]: string
}

export interface UploadDetailsResponse {
  id: number
  filename: string
  userId: number
  routeconfId: number
  nodeId: number
  status: string
  successCount: number
  duplicateCount: number
  invalidCount: number
  details: string
  prodate: string
  duplicate: number
  valid: number
  invalid: number
  total: number
}

export type Params = {
  pageNumber: number
  pageSize: number
  sender?: string
  senderStatus?: number
  routeid?: number
  branded?: number
}

export const downloadSenderSample = [
  {
    senderNumber: '8809600000111',
  },
  {
    senderNumber: '8809600000222',
  },
  {
    senderNumber: '8809600000333',
  },
  {
    senderNumber: '8809600000444',
  },
]

export const operator = [1, 2, 3, 4, 5, 6, 7]

export const statusOptions = [
  {
    id: '1',
    value: 'Active',
    label: 'Active',
  },
  {
    id: '2',
    value: 'Inactive',
    label: 'Inactive',
  },
]
